export default "__VITE_ASSET__2ecSMfki__"